import { useContext, useMemo } from 'react'
import { useParams, Navigate } from "react-router-dom"

import { AppContext } from '/providers/app-context'

import PageWrapper from '/components/page-wrapper'
import HelpText from '/help/template-issued-passes'
import Menu from '/components/templates/template-nav-menu'

import PassesTable from '/components/passes/passes-table'

const IssuedPasses = () => {

  const { templateId } = useParams()
  const { loadingTemplates, templates } = useContext(AppContext)

  const template = useMemo(() => {return templates.filter(t => t.template_id === templateId)[0]}, [templates, templateId])

  if (!loadingTemplates && !template) return <Navigate to="/templates" replace />

  const heading = useMemo(() => template ? `${template.name} ${template.archived ? " [archived]" : ""}` : "",[template])

  return (
    <PageWrapper title="Issued Passes" HelpText={HelpText} heading={heading} menu={<Menu template={template} />}>
      <PassesTable />
    </PageWrapper>
  )
}

export default IssuedPasses
